<template>
  <div class="form-page">
    <!-- phone -->
    <div v-if="showInput" class="ar-phone-container">
      <div class="ar-phone-code">
        <div class="form-phone__wrap">
          <input
            type="tel"
            inputmode="number"
            class="form-input"
            @keydown="handleKeydown"
            placeholder="Código"
            v-model="inputVal[0]"
            name="ar-phone-code"
            v-bind:class="{error: history[currentStep].showError}">
            <span class="form-input-floating-label">Código</span>
        </div>
        <transition name="fade">
          <span class="error-message" v-if="history[currentStep].showError">
            Ej: 11 para GBA o 380 La Rioja
          </span>
        </transition>
      </div>
      <div class="ar-phone">
        <div class="form-phone__wrap">
          <input
            type="tel"
            inputmode="number"
            class="form-input"
            @keydown="handleKeydown"
            placeholder="Teléfono Celular"
            v-model="inputVal[1]"
            name="ar-phone"
            v-bind:class="{error: history[currentStep].showError}">
            <span class="form-input-floating-label">Teléfono Celular</span>
        </div>
        <transition name="fade">
          <span class="error-message" v-if="history[currentStep].showError">
            Ingrese aquí el número de teléfono celular, sin incluir el "15". Ej: 44436789
          </span>
        </transition>
      </div>
    </div>
    <label v-show="history[currentStep].name === 'phone'" class="form-checkbox__wrap">
      <input name="agreements" :class="{error: accepted === ''}" v-model="checked" @change="checkboxChanged" type="checkbox">
      <span class="form-checkbox"></span>
      <p v-html="privacyCheckboxText"></p>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ARPhone',
  data () {
    return {
      inputVal: ['', ''],
      initValue: false,
      checked: false
    }
  },
  computed: {
    isValid () {
      let regexCode = '^[0-9]{2,4}$'
      let regexPhone = '^[0-9]{6,8}$'
      return (new RegExp(regexCode).test(this.inputVal[0]) || new RegExp(regexPhone).test(this.inputVal[1]))
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput,
      accepted: state => state.additionalParams.is_terms_accepted,
      privacyCheckboxText: state => state.config.params.privacyCheckboxText,
      additionalParams: state => state.additionalParams
    })
  },
  mounted () {
    let previosVal = this.history[this.currentStep].value || ''
    let previosCode = localStorage.getItem('ar-phone-code')
    let previosPhone = localStorage.getItem('ar-phone')
    if (previosVal && previosVal && previosPhone) {
      this.inputVal = [previosCode, previosPhone]
    } else {
      this.inputVal = ['', '']
    }
    this.checked = !!this.accepted
    if (this.history[this.currentStep].name !== 'phone') this.checked = true
  },
  watch: {
    inputVal: function (val, oldVal) {
      if (!this.initValue) {
        let vm = this
        setTimeout(function () {
          vm.initValue = true
        }, 100)
      } else {
        let formattedVal = '+54' + this.inputVal[0] + this.inputVal[1]
        this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, value: formattedVal })
        localStorage.setItem('ar-phone-code', this.inputVal[0])
        localStorage.setItem('ar-phone', this.inputVal[1])
        localStorage.setItem('phone', formattedVal)
      }
    }
  },
  methods: {
    checkboxChanged () {
      let val = this.checked ? 'on' : ''
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: val })
    },
    handleKeydown (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ph_wider {
    width: 70px;
  }
  .ar-phone-container {
    display: flex;
  }
  .ar-phone-code {
    width: 30%;
    margin-right: 20px;
  }
  .ar-phone {
    width: calc(70% - 20px);
  }
</style>



// WEBPACK FOOTER //
// src/components/fields/ARPhone.vue